'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildConversation = buildConversation;
exports.buildOfflineModeConversation = buildOfflineModeConversation;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _Conversation = require('conversations-schema/records/Conversation');

var _Conversation2 = _interopRequireDefault(_Conversation);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _propertyValues = require('conversations-schema/lib/propertyValues');

var _PubNubMessageTypes = require('conversations-schema/constants/PubNubMessageTypes');

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _ConversationStatusTypes = require('conversations-schema/constants/ConversationStatusTypes');

var _ConversationStatusTypes2 = _interopRequireDefault(_ConversationStatusTypes);

var _buildChatHistory = require('./buildChatHistory');

var _buildChatHistory2 = _interopRequireDefault(_buildChatHistory);

var _buildLatestMessage = require('./buildLatestMessage');

var _buildLatestMessage2 = _interopRequireDefault(_buildLatestMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Build a Conversation record from an JavaScript or Immutable object.
 * 
 * @param {Object|Map|Conversation} [props={}] - Properties to build the conversation from
 * @return {Conversation}
 *
 */
function buildConversation() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _pipe2.default)((0, _propertyValues.setDefaultValues)({
    portalId: _hubspot2.default.get(),
    status: _ConversationStatusTypes2.default.STARTED
  }), (0, _propertyValues.enforceValues)({
    chatHistory: (0, _buildChatHistory2.default)(props.chatHistory),
    latestMessage: (0, _buildLatestMessage2.default)((0, _get2.default)('latestMessage', props))
  }), _Conversation2.default)(props);
}

/**
 * Build a Conversation record for use in offline mode from away message text.
 * 
 * @param {Object} awayMessageProps - Away message properties (text, senderId, etc.)
 * @return {Conversation}
 */
function buildOfflineModeConversation(awayMessageProps) {
  var _metadata;

  var text = awayMessageProps.text,
      richText = awayMessageProps.richText,
      senderId = awayMessageProps.senderId;


  return buildConversation({
    chatHistory: {
      history: [{
        metadata: (_metadata = {}, _defineProperty(_metadata, _PubNubMessageTypes.MESSAGE_TYPE_ID, _PubNubMessageTypes.OFFLINE), _defineProperty(_metadata, 'from', _RoleTypes2.default.REP), _defineProperty(_metadata, 'text', text), _defineProperty(_metadata, 'richText', richText), _metadata),
        timestamp: Date.now(),
        senderId: senderId
      }]
    }
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/factories/ConversationFactory/index.js
// module id = 204
// module chunks = 0 1